module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_t1_b2.aa85b91a.svg";